// apolo/src/lib/loop/e6Gate.js — harness-uplift-r2 E6 glue.
//
// Binds the three E6 pure engines (checksRunner, noteStore, continueGuard) to
// their kill-switch flags in one place, out of the pure engines (Dependency
// Rule). Each wrapper is a no-op / passthrough when its flag is OFF. Never throws.

import { planChecks } from '../../review/checksRunner.js';
import { appendNote } from '../../notes/noteStore.js';
import { decideContinue } from '../continueGuard.js';
import { readChecksMultiEnabled, readAgentNotesEnabled, readContinueGuardEnabled } from '../../flags/sprintFlags.js';

/** Flag-gated: plan one review subagent per applicable check, or [] when OFF. */
function planChecksIfEnabled(checkFiles, opts) {
  if (!readChecksMultiEnabled()) return [];
  return planChecks(checkFiles, opts);
}

/** Flag-gated: append an agent note, or return the store unchanged when OFF. */
function appendNoteIfEnabled(existing, note) {
  if (!readAgentNotesEnabled()) return typeof existing === 'string' ? existing : '';
  return appendNote(existing, note);
}

/** Flag-gated: decide the one-shot auto-continue, or {action:'stop'} when OFF. */
function decideContinueIfEnabled(p) {
  if (!readContinueGuardEnabled()) return { action: 'stop' };
  return decideContinue(p);
}

/** Bundle of the three flag-gated E6 hooks, for injection into config builders. */
export function buildE6Hooks() {
  return {
    checksEnabled: readChecksMultiEnabled(),
    notesEnabled: readAgentNotesEnabled(),
    continueEnabled: readContinueGuardEnabled(),
    planChecks: planChecksIfEnabled,
    appendNote: appendNoteIfEnabled,
    decideContinue: decideContinueIfEnabled,
  };
}
